import {
  Component,
  OnInit,
  OnChanges,
  ChangeDetectionStrategy,
  SimpleChanges,
  ViewChild,
  Input,
  ViewEncapsulation,
  AfterViewInit,
  ChangeDetectorRef,
  Output,
  EventEmitter,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { BoobleModalService } from 'booble-modal';
import { ActivatedRoute, Router } from '@angular/router';
import { ESituationPersonalCheck } from 'src/app/domain/enums/situation-personal-check.enum';
import { CorporateAccountDto } from 'src/app/domain/models/dto/corporate-account.dto';
import { ClientsDto } from 'src/app/domain/models/dto/clients.dto';
import { ClientConfigComponent } from '../../modals/client-config/client-config.component';
import { ClientDetailsComponent } from '../../modals/client-details/client-details.component';
import { ResponseTableModel } from 'src/app/domain/models/response-table.model';
import {
  getStatusClass,
  getStatusLabel,
  getSituationIcon,
  getSituationLabel,
  getSituationClass,
} from 'src/app/shared/utils/client-status.util';

@Component({
  selector: 'app-table-clients-admin',
  templateUrl: './table-clients.component.html',
  styleUrls: ['./table-clients.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableComponent implements OnInit, OnChanges, AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @Input() data: ResponseTableModel<ClientsDto[]>;
  @Input() displayedColumns: string[];

  selection = new SelectionModel<any>(true, []);
  public dataSource: MatTableDataSource<ClientsDto>;
  @Input() pageNumber: number = 0;
  @Input() pageSize: number = 10;
  @Input() totalElements: number;

  tenant: string = '';
  situationPersonalCheck = ESituationPersonalCheck;

  @Output() pageChange = new EventEmitter<{
    pageNumber: number;
    pageSize: number;
  }>();

  constructor(
    private modalService: BoobleModalService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      const result = params.get('tenant');

      if (result) this.tenant = params.get('tenant');
    });
  }

  ngAfterViewInit(): void {
    this.initializeDataSource();
    this.initializeTableSort();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.data || changes.totalElements) {
      this.initializeDataSource();
      this.initializeTableSort();
      this.cdr.detectChanges();
    }
  }

  initializeTableSort() {
    if (this.sort && this.dataSource) {
      this.sort.active = 'companyName';
      this.sort.direction = 'asc';
      this.dataSource.sort = this.sort;
    }
  }

  private initializeDataSource() {
    const data = this.data?.content || [];
    this.dataSource = new MatTableDataSource(data);

    if (this.paginator) {
      this.paginator.length = this.totalElements || 0;
      this.paginator.pageIndex = this.pageNumber;
      this.paginator.pageSize = this.pageSize;

      this.paginator._intl.getRangeLabel = (
        page: number,
        pageSize: number,
        length: number
      ) => {
        if (length === 0 || pageSize === 0) {
          return '0 de ' + length;
        }

        length = Math.max(length, 0);
        const startIndex = page * pageSize;

        const endIndex =
          startIndex < length
            ? Math.min(startIndex + pageSize, length)
            : startIndex + pageSize;
        return 'Exibindo ' + endIndex + ' de ' + length + ' clientes';
      };
    }
  }

  chanePageEvent(event: { pageIndex: number; pageSize: number }) {
    this.pageNumber = event.pageIndex;
    this.pageSize = event.pageSize;

    sessionStorage.setItem('clients-page-size', this.pageSize.toString());

    this.pageChange.emit({
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
    });
  }

  onRowToggled(row: any) {
    this.selection.toggle(row);
  }

  isAllSelected() {
    return this.selection.selected?.length == this.dataSource.data.length;
  }

  openClientConfigModal(client: ClientsDto) {
    this.modalService.present(ClientConfigComponent, client);
  }

  openClientDetailsModal(client: ClientsDto) {
    this.modalService.present(ClientDetailsComponent, client);
  }

  toggleAll() {
    if (this.isAllSelected()) {
      this.selection.clear();
    } else {
      this.selection.select(...this.dataSource.data);
    }
  }

  getStatusLabel = getStatusLabel;
  getStatusClass = getStatusClass;
  getSituationIcon = getSituationIcon;
  getSituationLabel = getSituationLabel;
  getSituationClass = getSituationClass;
}
